<input type="text" [id]="identifier" class="form-control" debounce
  (event)="onInputCompany($event.target.value)" [matAutocomplete]="auto"
  aria-label="Digite o código ou o nome da empresa para encontrá-la"
  #empresa placeholder="Buscar empresa">

<mat-autocomplete #auto="matAutocomplete" [autoActiveFirstOption]="true" (optionSelected)="select($event)">
  <mat-option
    *ngFor="let company of selectableCompanies; let i = index" [value]="company"
    [id]="'empresa-' + i"
    [matTooltip]="getEmpresaDisplayName(company)"
    [attr.aria-label]="'Selecionar empresa ' + getEmpresaDisplayName(company)"
  >
    <div class="overflow-ellipsis">
      <span>{{ getEmpresaDisplayName(company) }}</span><br>
      <small>{{ getEmpresaDisplayCnpj(company) }}</small>
    </div>
  </mat-option>
</mat-autocomplete>